<script setup lang="ts">
  import { ref } from 'vue'
  import { EllipsisVerticalIcon } from 'lucide-vue-next'
  import { Button } from '@/components/ui/button'
  import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger
  } from '@/components/ui/dropdown-menu'
  import { useRouter } from 'vue-router'

  interface Option {
    label: string
    to?: string
    icon?: any
    onClick?: () => void
  }

  interface Props {
    options: Option[]
  }

  const props = defineProps<Props>()
  const router = useRouter()
  const handleOptionClick = (option: Option) => {
    if (option.onClick) {
      option.onClick()
    } else if (option.to) {
      router.push(option.to)
      console.log(`Navigating to: ${option.to}`)
    }
  }
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button
        variant="ghost"
        class="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
      >
        <EllipsisVerticalIcon class="h-4 w-4" />
        <span class="sr-only">Open menu</span>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      align="end"
      class="w-[160px]"
    >
      <DropdownMenuItem
        v-for="(option, index) in options"
        :key="index"
        class="cursor-pointer"
        @click="handleOptionClick(option)"
      >
        <component
          :is="option.icon"
          v-if="option.icon"
          class="mr-2 h-4 w-4"
        />
        {{ option.label }}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
